import { createContext, useState } from "react";
import { CONST_GENDER_MALE } from "../helpers/index"

export const ContextProfileUser = createContext(null);

export const defaultProfileUser = {
    first_name: "",
    email: "",
    password: "",
    gender: CONST_GENDER_MALE.toString(),
    birthday: "",
};
export const ProfileUserProvider = ({ children }) => {
    const [data, setData] = useState(defaultProfileUser);

    return (
        <ContextProfileUser.Provider value={{ data, setData }}>
            {children}
        </ContextProfileUser.Provider>
    );
};